import { useNavigate } from "react-router-dom";
import LogoComment from "src/assets/images/logo/logoblack.png";
import { classNames } from "src/helpers/mixins";
import { ParamsCardWall } from "src/types";

const CardWall: React.FC<ParamsCardWall> = ({
  autor,
  description,
  title,
  link,
  children,
  type,

  createdAt,
}) => {
  const navigate = useNavigate()
  return (
    <div
    onClick={() => link ? navigate(link): undefined}
    className={classNames( link ? 'cursor-pointer' : '', 'bg-white mb-4 rounded-md shadow-md px-4 py-2 h-fit')}>
      <div className="flex items-center gap-2">
        <img
          src={LogoComment}
          alt="isf"
          className="w-7 border-pic-card rounded-full p-0.5"
        />
        <div className="font-semibold text-base normal-case">{autor}{title} </div>
      </div>
      <div className="px-2 py-2 text-sm">  
        <div className="font-normal text-black">{description}</div>
        {children}
      </div>
    </div>
  );
};

export default CardWall;
